import type { ApiMe } from '@/fetcher'
import { formatMoscowDateTime, formatRate } from '@/helpers/rates'
import { useMarketRates } from '@/hooks/useMarketRates'
import { MarketRatesCard } from './MarketRatesCard'
import { SectionCard } from './SectionCard'

type RatesPageProps = {
  me: ApiMe
}

export const RatesPage = ({ me }: RatesPageProps) => {
  const isAdmin = me.user.role === 'admin'
  const { rates, isLoading, errorMessage, loadRates } = useMarketRates(isAdmin)

  return (
    <div className="mx-auto max-w-2xl space-y-4 px-4 py-8">
      {isAdmin && (
        <MarketRatesCard
          rates={rates}
          isLoading={isLoading}
          errorMessage={errorMessage}
          onRefresh={() => void loadRates()}
        />
      )}

      <SectionCard title="Курсы команд">
        <div className="divide-y divide-[var(--app-input)] rounded-[18px] bg-[var(--app-input)] px-4">
          {me.teams.map((team) => (
            <div
              key={team.id}
              className="flex items-center justify-between gap-4 py-3 first:pt-3 last:pb-3"
            >
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-[var(--app-text)]">
                  {team.name}
                </p>
                <p className="mt-1 text-xs text-[var(--app-muted)]">
                  Обновлён: {formatMoscowDateTime(team.rateUpdatedAt)}
                </p>
              </div>
              <p className="shrink-0 text-lg font-semibold text-[var(--app-text)]">
                {formatRate(team.usdtSellRate)}
              </p>
            </div>
          ))}
        </div>
      </SectionCard>
    </div>
  )
}
